module.exports = __webpack_public_path__ + "img/delivery.5f461561.png";